import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { Router } from '@angular/router';

import { ApiLoginService } from '@app/api/api-login.service';
import { ApiContentService } from '@app/api/api-content.service';
import { ApiPartnerService } from '@app/api/api-partner.service';
import { LoadJsService } from '../../load-js/load-js.service';

@Component({
  selector: 'app-orderservicecreate',
  templateUrl: './orderservicecreate.component.html',
  styleUrls: ['./orderservice.component.css']
})
export class OrderservicecreateComponent implements OnInit {
  @ViewChild("fileUploader", { static: false })
  fileUploader: ElementRef;
  constructor(
    public restApi:ApiPartnerService,
    private fb: FormBuilder,
    private login: ApiLoginService,
    public partnerService: ApiPartnerService,
    public LoadJsOrder: LoadJsService,
    private router: Router, 
  ) { }
  
  formIdProduct = this.fb.group({
    productsource : [''],
  });
  formOrderService = this.fb.group({
    partnerid: [''],
    nogrf: [''],
    noiom: [''],
    orderdate: [''],
    product: ['']
  })
  formProduct = this.fb.group({
    productid : [''],
    transactiontype: [''],
    note: [''],
    quota: ['']
  });

  btn_save = true
  btn_loading = false
  alert_failed = false
  alert_success = false
  table_product_kosong = true
  table_product_data = false
  
  selectedProduct: any = []
  data_table_product: any = []
  data_productsource:any={}
  data_partner:any={}
  data_product:any={}
  response_api:any={}

  ngOnInit() {
    //this.LoadJsOrder.loadScriptOrderService()
    this.sourceProduct()
    this.partner()
  }
  refreshPage() {
    //this.LoadJsOrder.loadScriptOrderService()
    this.sourceProduct()
    this.partner()
  }

  sourceProduct() {
    this.restApi.GetProductsource().subscribe((data: any) => { 
      this.data_productsource = data
      // console.log(this.data_productsource)
    });  
  }
  partner() {
    this.restApi.GetPartner().subscribe((data: {}) => { 
      this.data_partner = data
      // console.log(this.data_order_stb)
    });  
  }
  getIdProduct(e) {
    this.selectedProduct = []
    this.data_table_product = []
    this.formIdProduct.get('productsource').setValue(e.target.value);
    this.restApi.PostListProduct(this.formIdProduct.value).subscribe((data: {}) => { 
        this.data_product = data
        // console.log(this.data_product)
        for (let i = 0; i < this.data_product.data.length; i++) {
          // console.log(this.data_product.data[i].id);
          this.selectedProduct.push(
            {
              'id':this.data_product.data[i].id+'|'+this.data_product.data[i].productname,
              'name':this.data_product.data[i].productname
            }
          )
        }
        // console.log(this.selectedProduct)
      });  
  }
  resetForm(){
    this.formProduct.reset()
  }

  submitProduct() {
    // console.log(this.formProduct.get('productid').value)
    let id = this.formProduct.get('productid').value.split('|');
    this.formProduct.get('productid').setValue(id[0]);
    this.data_table_product.push(
      {
        'product':id[1],
        'productid':id[0],
        'transactiontype':1,
        'quota':this.formProduct.get('quota').value,
        'note':this.formProduct.get('note').value
      }
    )
    // console.log(this.data_table_product)
    // console.log(this.formProduct.value)
  }
  submitOrderService() {
    let date = this.formOrderService.get('orderdate').value
    let orderdate = date.year+'-'+date.month+'-'+date.day
    this.formOrderService.get('orderdate').setValue(orderdate)
    this.formOrderService.get('product').setValue(this.data_table_product)
    // console.log(this.formOrderService.get('orderdate').value)
    console.log(this.formOrderService.value)
    this.restApi.PostCreateOrderService(this.formOrderService.value)
      .subscribe((data: {}) => { 
        this.response_api = data
        console.log(data)
        if (this.response_api.status == true) {
          alert('Success Create')
          this.router.navigate(['/orderservice']);
        } else {
          this.alert_failed = true
          // this.loading_create = false
        }
      }
    );
  }
}
